import { useSearchParams } from 'react-router';

export const useQuery = (...params: string[]) => {
  const [query] = useSearchParams();
  return params.map((param) => query.get(param));
};
